import React, {Component} from 'react';
import IntakeFormRadTextEnum from "./enum/IntakeFormRadTextEnum";
import {DateInput, RadioInput, TextInput} from "../../../components";
import IntakeFormYesNoEnum from "../intakeform/enum/IntakeFormYesNoEnum";
import {YesNoRadioInput} from "../public/YesNoRadioInput";
import FamilySelect from "../FamilySelect";

class IntakeFormRadHealthHistory extends Component {

    renderConditionRow = (conditionKey, conditionLabel, selfValue, familyValue, familyWhoValue) => {
        const {readOnly, enumLabel, onChange} = this.props;

        return (
            <div className="row" key={conditionKey}>
                <div className="col-5 dim14-form-label">
                    {conditionLabel}
                </div>
                <div className="col-2">
                    <RadioInput
                        id={`${conditionKey}SelfRadioInput`}
                        value={selfValue}
                        disabled={readOnly}
                        options={IntakeFormYesNoEnum.toArray()}
                        displayProperty={enumLabel}
                        valueProperty={"key"}
                        onChange={(value) => onChange(`${conditionKey}Self`, value)}
                    />
                </div>
                <div className="col-4 d-flex">
                    <RadioInput
                        id={`${conditionKey}FamilyRadioInput`}
                        value={familyValue}
                        disabled={readOnly}
                        options={IntakeFormYesNoEnum.toArray()}
                        displayProperty={enumLabel}
                        valueProperty={"key"}
                        onChange={(value) => {
                            onChange(`${conditionKey}Family`, value);
                            if (value === "No") {
                                onChange(`${conditionKey}FamilyWho`, null);
                            }
                        }}
                    />
                    {familyValue === "Yes" &&
                    <FamilySelect value={familyWhoValue}
                                  style={{width: 150, height: 32}}
                                  disabled={readOnly}
                                  enumLabel={enumLabel}
                                  onChange={(value) =>
                                      onChange(`${conditionKey}FamilyWho`, value)}/>
                    }
                </div>
                <div className="col-1">
                </div>
            </div>
        );
    };


    render() {
        const {
            selectedLanguage, readOnly, enumLabel, onChange, onFieldGroupChanged, pushFormFieldRef,
            markAllSelf, markAllFamily,
            asthmaSelf, asthmaFamily, asthmaFamilyWho,
            tuberculosisSelf, tuberculosisFamily, tuberculosisFamilyWho,
            pneumoniaSelf, pneumoniaFamily, pneumoniaFamilyWho,
            covid19Self, covid19Family, covid19FamilyWho,
            cancerSelf, cancerFamily, cancerFamilyWho,
            osteoarthritisSelf, osteoarthritisFamily, osteoarthritisFamilyWho,
            osteoporosisSelf, osteoporosisFamily, osteoporosisFamilyWho,
            rheumatoidArthritisSelf, rheumatoidArthritisFamily, rheumatoidArthritisFamilyWho,
            thyroidDiseaseSelf, thyroidDiseaseFamily, thyroidDiseaseFamilyWho,
            abdominalDiseasesSelf, abdominalDiseasesFamily, abdominalDiseasesFamilyWho,
            breastDiseasesSelf, breastDiseasesFamily, breastDiseasesFamilyWho,
            diabetesSelf, diabetesFamily, diabetesFamilyWho,
            kidneyDiseaseSelf, kidneyDiseaseFamily, kidneyDiseaseFamilyWho,
            heartDiseaseSelf, heartDiseaseFamily, heartDiseaseFamilyWho,
            otherConditionSelf, otherConditionFamily, otherConditionFamilyWho,
            onMedicationSupplements, medicationDetails,
            everHadSurgery, surgeryDetails,
            currentlyReceivingHealthcare, healthcareDetails,
            hadPreviousImaging, previousImagingDetails,
            exerciseType, smokesCurrent, smokesHistory, consumesAlcohol,
            currentlyPregnant, lastMenstrualPeriod, lastMenstrualPeriodDetails,
            hadContrastDyeLast6Days, calciumVitaminDToday, calciumVitaminDLast24Hours,
            nuclearMedicineScanBariumLast6Days, dexaScanLast12Months, fastingForUltrasoundXray
        } = this.props;

        const medicationOptions = [
            {key: "No", name: IntakeFormRadTextEnum.No_Medication[selectedLanguage]},
            {key: "Current", name: IntakeFormRadTextEnum.Current_Medication[selectedLanguage]},
            {key: "Previous", name: IntakeFormRadTextEnum.Previous_Medication[selectedLanguage]},
            {key: "Long-term", name: IntakeFormRadTextEnum.Long_term_Medication[selectedLanguage]}
        ];

        const pregnancyOptions = [
            {key: "Yes", name: IntakeFormRadTextEnum.Yes[selectedLanguage]},
            {key: "No", name: IntakeFormRadTextEnum.No[selectedLanguage]},
            {key: "NA", name: IntakeFormRadTextEnum.NA[selectedLanguage]}
        ];

        return (
            <>
                <h3 className="text-center mb-3">
                    <b>{IntakeFormRadTextEnum.Health_History[selectedLanguage]}</b>
                </h3>
                <div className="container dim14-form-row-align">
                    
                    {/* Medical Conditions Section */}
                    <div className="row">
                        <div className="col-12 dim14-form-label">
                            <p>
                                <b>
                                    <u>
                                        {IntakeFormRadTextEnum.You_Or_Family_Suffer[selectedLanguage]}
                                    </u>
                                </b>
                            </p>
                        </div>
                    </div>
                    
                    {/* Header Row */}
                    <div className="row">
                        <div className="col-5"></div>
                        <div className="col-2 text-center">
                            <p>
                                <b>
                                    <u> {IntakeFormRadTextEnum.Self[selectedLanguage]} </u>
                                </b>
                            </p>
                        </div>
                        <div className="col-4 text-center">
                            <p>
                                <b>
                                    <u> {IntakeFormRadTextEnum.Family[selectedLanguage]} </u>
                                </b>
                            </p>
                        </div>
                        <div className="col-1"></div>
                    </div>

                    {/* Mark All Row */}
                    {!readOnly && (
                        <div className="row">
                            <div className="col-5 dim14-form-label text-right">
                                {IntakeFormRadTextEnum.Mark_All[selectedLanguage]}
                            </div>
                            <div className="col-2">
                                <RadioInput
                                    id="markAllSelfRadioInput"
                                    value={markAllSelf}
                                    disabled={readOnly}
                                    options={IntakeFormYesNoEnum.toArray()}
                                    displayProperty={enumLabel}
                                    valueProperty={"key"}
                                    onChange={(value) => {
                                        onFieldGroupChanged({
                                            asthmaSelf: value,
                                            tuberculosisSelf: value,
                                            pneumoniaSelf: value,
                                            covid19Self: value,
                                            cancerSelf: value,
                                            osteoarthritisSelf: value,
                                            osteoporosisSelf: value,
                                            rheumatoidArthritisSelf: value,
                                            thyroidDiseaseSelf: value,
                                            abdominalDiseasesSelf: value,
                                            breastDiseasesSelf: value,
                                            diabetesSelf: value,
                                            kidneyDiseaseSelf: value,
                                            heartDiseaseSelf: value,
                                            markAllSelf: value
                                        });
                                    }}
                                />
                            </div>
                            <div className="col-4">
                                <RadioInput
                                    id="markAllFamilyRadioInput"
                                    value={markAllFamily}
                                    disabled={readOnly}
                                    options={IntakeFormYesNoEnum.toArray()}
                                    displayProperty={enumLabel}
                                    valueProperty={"key"}
                                    onChange={(value) => {
                                        onFieldGroupChanged({
                                            asthmaFamily: value,
                                            tuberculosisFamily: value,
                                            pneumoniaFamily: value,
                                            covid19Family: value,
                                            cancerFamily: value,
                                            osteoarthritisFamily: value,
                                            osteoporosisFamily: value,
                                            rheumatoidArthritisFamily: value,
                                            thyroidDiseaseFamily: value,
                                            abdominalDiseasesFamily: value,
                                            breastDiseasesFamily: value,
                                            diabetesFamily: value,
                                            kidneyDiseaseFamily: value,
                                            heartDiseaseFamily: value,
                                            otherConditionFamily: value,
                                            markAllFamily: value
                                        });

                                        if (value === "No") {
                                            onFieldGroupChanged({
                                                asthmaFamilyWho: null,
                                                tuberculosisFamilyWho: null,
                                                pneumoniaFamilyWho: null,
                                                covid19FamilyWho: null,
                                                cancerFamilyWho: null,
                                                osteoarthritisFamilyWho: null,
                                                osteoporosisFamilyWho: null,
                                                rheumatoidArthritisFamilyWho: null,
                                                thyroidDiseaseFamilyWho: null,
                                                abdominalDiseasesFamilyWho: null,
                                                breastDiseasesFamilyWho: null,
                                                diabetesFamilyWho: null,
                                                kidneyDiseaseFamilyWho: null,
                                                heartDiseaseFamilyWho: null,
                                                otherConditionFamilyWho: null
                                            });
                                        }
                                    }}
                                />
                            </div>
                            <div className="col-1"></div>
                        </div>
                    )}

                    {/* Medical Conditions */}
                    {this.renderConditionRow('asthma', IntakeFormRadTextEnum.Asthma[selectedLanguage], asthmaSelf, asthmaFamily, asthmaFamilyWho)}
                    {this.renderConditionRow('tuberculosis', IntakeFormRadTextEnum.Tuberculosis[selectedLanguage], tuberculosisSelf, tuberculosisFamily, tuberculosisFamilyWho)}
                    {this.renderConditionRow('pneumonia', IntakeFormRadTextEnum.Pneumonia[selectedLanguage], pneumoniaSelf, pneumoniaFamily, pneumoniaFamilyWho)}
                    {this.renderConditionRow('covid19', IntakeFormRadTextEnum.COVID_19[selectedLanguage], covid19Self, covid19Family, covid19FamilyWho)}
                    {this.renderConditionRow('cancer', IntakeFormRadTextEnum.Cancer[selectedLanguage], cancerSelf, cancerFamily, cancerFamilyWho)}
                    {this.renderConditionRow('osteoarthritis', IntakeFormRadTextEnum.Osteoarthritis[selectedLanguage], osteoarthritisSelf, osteoarthritisFamily, osteoarthritisFamilyWho)}
                    {this.renderConditionRow('osteoporosis', IntakeFormRadTextEnum.Osteoporosis[selectedLanguage], osteoporosisSelf, osteoporosisFamily, osteoporosisFamilyWho)}
                    {this.renderConditionRow('rheumatoidArthritis', IntakeFormRadTextEnum.Rheumatoid_Arthritis[selectedLanguage], rheumatoidArthritisSelf, rheumatoidArthritisFamily, rheumatoidArthritisFamilyWho)}
                    {this.renderConditionRow('thyroidDisease', IntakeFormRadTextEnum.Thyroid_Disease[selectedLanguage], thyroidDiseaseSelf, thyroidDiseaseFamily, thyroidDiseaseFamilyWho)}
                    {this.renderConditionRow('abdominalDiseases', IntakeFormRadTextEnum.Abdominal_Diseases[selectedLanguage], abdominalDiseasesSelf, abdominalDiseasesFamily, abdominalDiseasesFamilyWho)}
                    {this.renderConditionRow('breastDiseases', IntakeFormRadTextEnum.Breast_Diseases[selectedLanguage], breastDiseasesSelf, breastDiseasesFamily, breastDiseasesFamilyWho)}
                    {this.renderConditionRow('diabetes', IntakeFormRadTextEnum.Diabetes[selectedLanguage], diabetesSelf, diabetesFamily, diabetesFamilyWho)}
                    {this.renderConditionRow('kidneyDisease', IntakeFormRadTextEnum.Kidney_Disease[selectedLanguage], kidneyDiseaseSelf, kidneyDiseaseFamily, kidneyDiseaseFamilyWho)}
                    {this.renderConditionRow('heartDisease', IntakeFormRadTextEnum.Heart_Disease[selectedLanguage], heartDiseaseSelf, heartDiseaseFamily, heartDiseaseFamilyWho)}

                    {/* Other Condition */}
                    <div className="row">
                        <div className="col-5 dim14-form-label">
                            {IntakeFormRadTextEnum.Other[selectedLanguage]}:
                        </div>
                        <div className="col-2">
                            <TextInput
                                value={otherConditionSelf}
                                style={{width: "100%", height: 32}}
                                disabled={readOnly}
                                placeholder="Specify condition..."
                                onChange={(value) => onChange("otherConditionSelf", value)}
                            />
                        </div>
                        <div className="col-4 d-flex">
                            <RadioInput
                                id="otherConditionFamilyRadioInput"
                                value={otherConditionFamily}
                                disabled={readOnly}
                                options={IntakeFormYesNoEnum.toArray()}
                                displayProperty={enumLabel}
                                valueProperty={"key"}
                                onChange={(value) => {
                                    onChange("otherConditionFamily", value);
                                    if (value === "No") {
                                        onChange("otherConditionFamilyWho", null);
                                    }
                                }}
                            />
                            {otherConditionFamily === "Yes" &&
                            <FamilySelect value={otherConditionFamilyWho}
                                          style={{width: 150, height: 32}}
                                          disabled={readOnly}
                                          enumLabel={enumLabel}
                                          onChange={(value) =>
                                              onChange("otherConditionFamilyWho", value)}/>
                            }
                        </div>
                        <div className="col-1">
                        </div>
                    </div>

                    <div className="mt-4"></div>

                    {/* Medications */}
                    <div className="row">
                        <div className="col-4 dim14-form-label">
                            {IntakeFormRadTextEnum.On_Any_Medication_Supplements[selectedLanguage]}
                        </div>
                        <div className="col-8">
                            <YesNoRadioInput
                                value={onMedicationSupplements !== "No" ? "Yes" : "No"}
                                readOnly={readOnly}
                                enumLabel={enumLabel}
                                onValueChange={(value) => {
                                    if (value === "No") {
                                        onChange("onMedicationSupplements", "No");
                                        onChange("medicationDetails", "");
                                    } else if (value === "Yes" && onMedicationSupplements === "No") {
                                        // Reset to empty when switching from No to Yes
                                        onChange("onMedicationSupplements", "");
                                    }
                                }}
                            />
                        </div>
                    </div>

                    {/* Medication Type - Only show if Yes is selected */}
                    {onMedicationSupplements !== "No" && (
                        <div className="row">
                            <div className="col-4 dim14-form-label">
                                {IntakeFormRadTextEnum.If_Yes_Name_Medication[selectedLanguage]}:
                            </div>
                            <div className="col-8">
                                <RadioInput
                                    id="medicationTypeRadioInput"
                                    value={onMedicationSupplements === "No" ? "" : onMedicationSupplements}
                                    disabled={readOnly}
                                    options={medicationOptions.filter(option => option.key !== "No")}
                                    displayProperty="name"
                                    valueProperty="key"
                                    onChange={(value) => {
                                        onChange("onMedicationSupplements", value);
                                        if (value === "No") {
                                            onChange("medicationDetails", "");
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    )}

                    {onMedicationSupplements && onMedicationSupplements !== "No" && onMedicationSupplements !== "" && (
                        <div className="row">
                            <div className="col-4 dim14-form-label">
                                {IntakeFormRadTextEnum.If_Yes_Name_Medication[selectedLanguage]}:
                            </div>
                            <div className="col-8">
                                <TextInput
                                    className="w-100"
                                    value={medicationDetails}
                                    disabled={readOnly}
                                    placeholder="Name of medication/supplement..."
                                    onChange={(value) => onChange("medicationDetails", value)}
                                />
                            </div>
                        </div>
                    )}

                    {/* Surgery History */}
                    <div className="row">
                        <div className="col-4 dim14-form-label">
                            {IntakeFormRadTextEnum.Ever_Had_Surgery[selectedLanguage]}
                        </div>
                        <div className="col-8">
                            <RadioInput
                                id="surgeryRadioInput"
                                value={everHadSurgery}
                                disabled={readOnly}
                                options={IntakeFormYesNoEnum.toArray()}
                                displayProperty={enumLabel}
                                valueProperty={"key"}
                                onChange={(value) => onChange("everHadSurgery", value)}
                            />
                        </div>
                    </div>

                    {everHadSurgery === "Yes" && (
                        <div className="row">
                            <div className="col-4 dim14-form-label">
                                {IntakeFormRadTextEnum.If_Yes_When_What_Surgery[selectedLanguage]}:
                            </div>
                            <div className="col-8">
                                <TextInput
                                    className="w-100"
                                    value={surgeryDetails}
                                    disabled={readOnly}
                                    placeholder="When and what surgery?"
                                    onChange={(value) => onChange("surgeryDetails", value)}
                                />
                            </div>
                        </div>
                    )}

                    {/* Current Healthcare */}
                    <div className="row">
                        <div className="col-4 dim14-form-label">
                            {IntakeFormRadTextEnum.Currently_Receiving_Healthcare[selectedLanguage]}
                        </div>
                        <div className="col-8">
                            <RadioInput
                                id="healthcareRadioInput"
                                value={currentlyReceivingHealthcare}
                                disabled={readOnly}
                                options={IntakeFormYesNoEnum.toArray()}
                                displayProperty={enumLabel}
                                valueProperty={"key"}
                                onChange={(value) => onChange("currentlyReceivingHealthcare", value)}
                            />
                        </div>
                    </div>

                    {currentlyReceivingHealthcare === "Yes" && (
                        <div className="row">
                            <div className="col-4 dim14-form-label">
                                {IntakeFormRadTextEnum.If_Yes_Please_Specify[selectedLanguage]}:
                            </div>
                            <div className="col-8">
                                <TextInput
                                    className="w-100"
                                    value={healthcareDetails}
                                    disabled={readOnly}
                                    placeholder="Please specify..."
                                    onChange={(value) => onChange("healthcareDetails", value)}
                                />
                            </div>
                        </div>
                    )}

                    {/* Previous Imaging */}
                    <div className="row">
                        <div className="col-4 dim14-form-label">
                            {IntakeFormRadTextEnum.Had_Previous_Imaging[selectedLanguage]}
                        </div>
                        <div className="col-8">
                            <RadioInput
                                id="imagingRadioInput"
                                value={hadPreviousImaging}
                                disabled={readOnly}
                                options={IntakeFormYesNoEnum.toArray()}
                                displayProperty={enumLabel}
                                valueProperty={"key"}
                                onChange={(value) => {
                                    onChange("hadPreviousImaging", value);
                                    if (value !== "Yes") {
                                        onChange("previousImagingDetails", "");
                                    }
                                }}
                            />
                        </div>
                    </div>

                    {hadPreviousImaging === "Yes" && (
                        <div className="row">
                            <div className="col-4 dim14-form-label">
                                {IntakeFormRadTextEnum.If_Yes_Please_Specify[selectedLanguage]}:
                            </div>
                            <div className="col-8">
                                <TextInput
                                    className="w-100"
                                    value={previousImagingDetails}
                                    disabled={readOnly}
                                    placeholder="Please specify..."
                                    onChange={(value) => onChange("previousImagingDetails", value)}
                                />
                            </div>
                        </div>
                    )}

                    {/* Lifestyle */}
                    <div className="row">
                        <div className="col-4 dim14-form-label">
                            {IntakeFormRadTextEnum.Exercise_Type[selectedLanguage]}
                        </div>
                        <div className="col-8">
                            <RadioInput
                                id="exerciseTypeRadioInput"
                                value={exerciseType}
                                disabled={readOnly}
                                options={[
                                    {key: "Recreational", name: IntakeFormRadTextEnum.Exercise_Recreational[selectedLanguage]},
                                    {key: "Classes", name: IntakeFormRadTextEnum.Exercise_Classes[selectedLanguage]},
                                    {key: "Personal Trainer", name: IntakeFormRadTextEnum.Exercise_Personal_Trainer[selectedLanguage]},
                                    {key: "Performance Sports", name: IntakeFormRadTextEnum.Exercise_Performance_Sports[selectedLanguage]}
                                ]}
                                displayProperty="name"
                                valueProperty="key"
                                onChange={(value) => onChange("exerciseType", value)}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-4 dim14-form-label">
                            {IntakeFormRadTextEnum.Do_You_Smoke[selectedLanguage]}
                        </div>
                        <div className="col-8">
                            <RadioInput
                                id="smokesCurrentRadioInput"
                                value={smokesCurrent}
                                disabled={readOnly}
                                options={IntakeFormYesNoEnum.toArray()}
                                displayProperty={enumLabel}
                                valueProperty={"key"}
                                onChange={(value) => onChange("smokesCurrent", value)}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-4 dim14-form-label">
                            {IntakeFormRadTextEnum.Have_You_Ever_Smoked[selectedLanguage]}
                        </div>
                        <div className="col-8">
                            <RadioInput
                                id="smokesHistoryRadioInput"
                                value={smokesHistory}
                                disabled={readOnly}
                                options={IntakeFormYesNoEnum.toArray()}
                                displayProperty={enumLabel}
                                valueProperty={"key"}
                                onChange={(value) => onChange("smokesHistory", value)}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-4 dim14-form-label">
                            {IntakeFormRadTextEnum.Do_You_Consume_Alcohol[selectedLanguage]}
                        </div>
                        <div className="col-8">
                            <RadioInput
                                id="consumesAlcoholRadioInput"
                                value={consumesAlcohol}
                                disabled={readOnly}
                                options={IntakeFormYesNoEnum.toArray()}
                                displayProperty={enumLabel}
                                valueProperty={"key"}
                                onChange={(value) => onChange("consumesAlcohol", value)}
                            />
                        </div>
                    </div>

                    {/* Pregnancy Status */}
                    <div className="row">
                        <div className="col-4 dim14-form-label">
                            {IntakeFormRadTextEnum.Currently_Pregnant[selectedLanguage]}
                        </div>
                        <div className="col-8">
                            <RadioInput
                                id="pregnancyRadioInput"
                                value={currentlyPregnant}
                                disabled={readOnly}
                                options={pregnancyOptions}
                                displayProperty="name"
                                valueProperty="key"
                                onChange={(value) => {
                                    onChange("currentlyPregnant", value);
                                    if (value === "Yes" || value === "NA") {
                                        onChange("lastMenstrualPeriod", "");
                                        onChange("lastMenstrualPeriodDetails", "");
                                    }
                                }}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-4 dim14-form-label">
                            {IntakeFormRadTextEnum.Last_Menstrual_Period[selectedLanguage]}
                            <br />
                            <small>{IntakeFormRadTextEnum.Date_Format_DD_MM_YYYY[selectedLanguage]}</small>
                        </div>
                        <div className="col-8">
                            <DateInput
                                className={
                                    readOnly
                                        ? "dim14-datepicker DateInputDisabledBackground"
                                        : "dim14-datepicker"
                                }
                                disableFuture="true"
                                disabled={readOnly}
                                value={lastMenstrualPeriod ? new Date(lastMenstrualPeriod) : null}
                                onChange={(val) => {
                                    onChange("lastMenstrualPeriod", val);
                                    if (!val) {
                                        onChange("lastMenstrualPeriodDetails", "");
                                    }
                                }}
                            />
                        </div>
                    </div>

                    {lastMenstrualPeriod && (
                        <div className="row">
                            <div className="col-4 dim14-form-label">
                                {IntakeFormRadTextEnum.If_Yes_Please_Specify[selectedLanguage]}:
                            </div>
                            <div className="col-8">
                                <TextInput
                                    className="w-100"
                                    value={lastMenstrualPeriodDetails || ""}
                                    disabled={readOnly}
                                    placeholder="Please specify..."
                                    onChange={(value) => onChange("lastMenstrualPeriodDetails", value)}
                                />
                            </div>
                        </div>
                    )}

                    <hr />

                    {/* Had contrast dye last 6 days */}
                    <div className="row">
                        <div className="col-12 dim14-form-label">
                            {IntakeFormRadTextEnum.Had_Contrast_Dye_Last_6_Days[selectedLanguage]}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <YesNoRadioInput
                                value={hadContrastDyeLast6Days}
                                readOnly={readOnly}
                                enumLabel={enumLabel}
                                onValueChange={(value) => onChange("hadContrastDyeLast6Days", value)}
                            />
                        </div>
                    </div>

                    {/* Calcium Vitamin D Today */}
                    <div className="row">
                        <div className="col-12 dim14-form-label">
                            {IntakeFormRadTextEnum.Calcium_Vitamin_D_Today[selectedLanguage]}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <YesNoRadioInput
                                value={calciumVitaminDToday}
                                readOnly={readOnly}
                                enumLabel={enumLabel}
                                onValueChange={(value) => onChange("calciumVitaminDToday", value)}
                            />
                        </div>
                    </div>

                    {/* Calcium Vitamin D Last 24 Hours */}
                    <div className="row">
                        <div className="col-12 dim14-form-label">
                            {IntakeFormRadTextEnum.Calcium_Vitamin_D_Last_24_Hours[selectedLanguage]}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <YesNoRadioInput
                                value={calciumVitaminDLast24Hours}
                                readOnly={readOnly}
                                enumLabel={enumLabel}
                                onValueChange={(value) => onChange("calciumVitaminDLast24Hours", value)}
                            />
                        </div>
                    </div>

                    {/* Nuclear medicine scan barium last 6 days */}
                    <div className="row">
                        <div className="col-12 dim14-form-label">
                            {IntakeFormRadTextEnum.Nuclear_Medicine_Scan_Barium_Last_6_Days[selectedLanguage]}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <YesNoRadioInput
                                value={nuclearMedicineScanBariumLast6Days}
                                readOnly={readOnly}
                                enumLabel={enumLabel}
                                onValueChange={(value) => onChange("nuclearMedicineScanBariumLast6Days", value)}
                            />
                        </div>
                    </div>

                    {/* DEXA scan last 12 months */}
                    <div className="row">
                        <div className="col-12 dim14-form-label">
                            {IntakeFormRadTextEnum.Dexa_Scan_Last_12_Months[selectedLanguage]}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <YesNoRadioInput
                                value={dexaScanLast12Months}
                                readOnly={readOnly}
                                enumLabel={enumLabel}
                                onValueChange={(value) => onChange("dexaScanLast12Months", value)}
                            />
                        </div>
                    </div>

                    {/* Fasting for ultrasound/xray */}
                    <div className="row">
                        <div className="col-12 dim14-form-label">
                            {IntakeFormRadTextEnum.Fasting_For_Ultrasound_Xray[selectedLanguage]}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <RadioInput
                                id="fastingForUltrasoundXrayRadioInput"
                                value={fastingForUltrasoundXray}
                                disabled={readOnly}
                                options={[
                                    {key: "Yes", name: IntakeFormRadTextEnum.Yes[selectedLanguage]},
                                    {key: "No", name: IntakeFormRadTextEnum.No[selectedLanguage]},
                                    {key: "Not applicable", name: IntakeFormRadTextEnum.Not_Applicable[selectedLanguage]}
                                ]}
                                displayProperty="name"
                                valueProperty="key"
                                onChange={(value) => onChange("fastingForUltrasoundXray", value)}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default IntakeFormRadHealthHistory;